module.exports = __webpack_public_path__ + "media/smw_keyhole_exit.a8b8504b.ogg";